import { render, staticRenderFns } from "./InsuranceCompany.vue?vue&type=template&id=17d6a636&scoped=true"
import script from "./InsuranceCompany.vue?vue&type=script&lang=js"
export * from "./InsuranceCompany.vue?vue&type=script&lang=js"
import style0 from "./InsuranceCompany.vue?vue&type=style&index=0&id=17d6a636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d6a636",
  null
  
)

export default component.exports